
export class TemperatureNavigationModule {
    static get TemperatureCompliance(): string { return "app.temperature.compliance"; }
    static get Reefer(): string { return "app.temperature.reefer"; }
    static get Default(): string { return this.TemperatureCompliance; }
    static get ParentRoot(): string { return "app.temperature"; }
}
